import _kebabCase from 'lodash/kebabCase';
import { PROJECT_BASENAME } from 'constants/env';

export const getGiftTableLink = (
  { id, name, nombre } = {},
  addDomain = true
) => {
  const finalName = nombre || name;

  if (!id || !finalName) return null;

  const domain = `${window.location.origin}${PROJECT_BASENAME}`;

  const nameKebabCase = _kebabCase(finalName);
  const link = `${addDomain ? domain : ''}${id}/${nameKebabCase}`;
  return link;
};
